import type * as Leaflet from 'leaflet'

const LEAFLET_ICON_BASE = 'https://unpkg.com/leaflet@1.9.4/dist/images'

/**
 * Corrige les URLs des marqueurs Leaflet par défaut (chemins relatifs cassés en prod avec Vite/Nuxt).
 * @param {typeof Leaflet} L - Namespace Leaflet (`(await import('leaflet')).default`).
 */
export function configureLeafletDefaultIcons(L: typeof Leaflet): void {
  delete (L.Icon.Default.prototype as { _getIconUrl?: unknown })._getIconUrl
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: `${LEAFLET_ICON_BASE}/marker-icon-2x.png`,
    iconUrl: `${LEAFLET_ICON_BASE}/marker-icon.png`,
    shadowUrl: `${LEAFLET_ICON_BASE}/marker-shadow.png`,
  })
}
